/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Grid, Segment, Divider, Form, Accordion,
  Checkbox, Pagination, Icon, Dropdown,
  Dimmer, DimmerDimmable
} from "semantic-ui-react";
import InitLoader from "./login-config/InitLoader";
import Chart from "react-apexcharts";
import ApexChart from "apexcharts";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();

const dropdownOptions = [
  {
    key: "amplitude",
    text: Strings.AMPLITUDE,
    value: "amplitude"
  },
  {
    key: "noise",
    text: Strings.NOISE,
    value: "noise"
  },
  {
    key: "deviation",
    text: Strings.DEVIATION,
    value: "deviation"
  }
];

class BarGraph extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeChart: "",

      isDropdownDisabled: true,

      isAddrCheckboxActive: true,
      isDescCheckboxActive: false,
      isAscCheckboxActive: false,

      amplitudeSeries: [],
      errorMessages: [],

      activePage: 1,
      numOfPages: 1,

      ascCheckboxLabel: Strings.AMPLITUDE_ASC,
      descCheckboxLabel: Strings.AMPLITUDE_DESC,

      graphType: "",

      // These maps are used to divide the device's list into
      // pages. The keys are 0 to n, and each key represents a page
      ascAddrcAmplitudePageMap: new Map(),     // Ordered by address ascending
      ascAmplitudePageMap: new Map(),          // Ordered by amplitude ascending
      descAmplitudePageMap: new Map(),         // Ordered by amplitude descending

      ascAddrcNoisePageMap: new Map(),  // Ordered by address ascending
      ascNoisePageMap: new Map(),       // Ordered by noise value ascending        
      descNoisePageMap: new Map(),      // Ordered by noise value descending

      ascAddrcDeviationPageMap: new Map(),  // Ordered by address ascending
      ascDeviationPageMap: new Map(),       // Ordered by deviation value ascending        
      descDeviationPageMap: new Map(),      // Ordered by deviation value descending

      options: {
        tooltip: {
          enabled: true,
          x: {
            show: true,
            formatter: function (val) {
              return Strings.ADDRESS + ": " + val;
            },
          },
          marker: {
            show: false,
          },
        },
        chart: {
          id: Constants.BAR_GRAPH_CHART_ID,
          animations: {
            enabled: false
          },
          toolbar: {
            show: false
          },
          locales: [{
            "name": "pt-br",
            "options": {
              "toolbar": {
                "exportToSVG": "Baixar SVG",
                "exportToPNG": "Baixar PNG",
                "exportToCSV": "Baixar CSV",
                "menu": "Baixar"
              }
            }
          }],
          defaultLocale: "pt-br",
        },
        title: {
          text: "",
          align: "center"
        },
        xaxis: {
          type: "category",
          title: {
            text: Strings.ADDRESS
          },
          crosshairs: {
            show: "true"
          }
        },
        yaxis: {
          min: 0,
          max: Constants.AMPLITUDE_MAX_Y_AXIS,
          labels: {
            formatter: function (val) {
              return val.toFixed(2).replace(".", ",") + " " + Strings.VOLTAGE_PEAK_TO_PEAK;
            },
          },
          title: {
            text: Strings.VOLTAGE_V_PEAK_TO_PEAK
          },
        },
        colors: [function ({ value }) {
          return (UtilsInstance.getASiBarGraphColorBasedOnValue(value, Constants));
        }],
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top",
            }
          }
        },
        dataLabels: {
          formatter: function (val) {
            if (val < 0) {
              // Don't show the number above a bar with
              // negative values
              return "";
            }
            else if (val === 0) {
              return "0,00";
            }
            else {
              return val;
            }
          },
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
            colors: ["#212121"],
          },
          offsetY: -22,
        },
      },
      // loading
      percent: 100
    };
    this.InitLoaderRef = React.createRef();
  }

  // Since the devices in ASi protocol are not numbered with simple integers
  // We need to convert, 1A and 1B for exemple, into sortable integers
  // Every device that has A in its address has its number as the sortable integer
  // Every device that has B in its addres, has its number + 32 as the sortable integer
  // Every device that has master in its name has its number be 0
  addOrderValueToDevices = (devices) => {
    let aRegExp = new RegExp("A");
    let bRegExp = new RegExp("B");

    for (let i = 0; i < devices.length; i++) {
      let deviceName = devices[i].address;

      if (deviceName.includes("A")) {
        devices[i].order = parseInt(deviceName.replace(aRegExp, ""));
      }
      else if (deviceName.includes("B")) {
        devices[i].order = parseInt(deviceName.replace(bRegExp, "")) + 32;
      }
      else if (UtilsInstance.treatUppercase(deviceName) === UtilsInstance.treatUppercase(Strings.MASTER)) {
        devices[i].order = 0;
      }
      else {
        devices[i].order = parseInt(deviceName);
      }
    }

    return devices.sort(UtilsInstance.sortBy("order", false, parseInt));
  }

  retrieveData = async () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "liveList/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ devices: this.addOrderValueToDevices(data) }, () => {
        // Set the state of the number of pages, it will be used for everything else
        this.setState({ numOfPages: Math.ceil(this.state.devices.length / Constants.MAX_DEV_PER_PAGE) }, () => {
          // Save the mappings
          this.setState({
            // Amplitude
            ascAddrcAmplitudePageMap: this.createAscAddrAmpPageMap(),
            ascAmplitudePageMap: this.createAscAmpPageMap(),
            descAmplitudePageMap: this.createDescAmpPageMap(),

            // Noise
            ascAddrcNoisePageMap: this.createAscAddrNoisePageMap(),
            ascNoisePageMap: this.createAscNoisePageMap(),
            descNoisePageMap: this.createDescNoisePageMap(),

            // Deviation
            ascAddrcDeviationPageMap: this.createAscAddrDeviationPageMap(),
            ascDeviationPageMap: this.createAscDeviationPageMap(),
            descDeviationPageMap: this.createDescDeviationPageMap(),

            isDropdownDisabled: false
          }, () => {
            if (this.state.graphType === "amplitude") {
              this.showAmpGraph();
            }
            else if (this.state.graphType === "noise") {
              this.showNoiseGraph();
            }
            else if (this.state.graphType === "deviation") {
              this.showDeviationGraph();
            }
          });
        });
      }));
  }

  retrievePercentData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "getCurrentPercent/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ percent: data.percent }, () => {
        if (this.state.percent < 100) {
          this.InitLoaderRef.current.changeLoaderText(
            <>
              <p>
                {Strings.INITIALIZING_SCOPE_DP}<br />
                {Strings.LOADING}: {this.state.percent}%
              </p>
            </>
          );
        }
      }));
  }

  showAmpGraph = () => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    if (this.state.isAddrCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.AMPLITUDE,
        data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
      }]);

      this.updateAmpChartOptions(this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1));
    }
    else if (this.state.isAscCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.AMPLITUDE,
        data: this.state.ascAmplitudePageMap.get(this.state.activePage - 1)
      }]);

      this.updateAmpChartOptions(this.state.ascAmplitudePageMap.get(this.state.activePage - 1));
    }
    else if (this.state.isDescCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.AMPLITUDE,
        data: this.state.descAmplitudePageMap.get(this.state.activePage - 1)
      }]);

      this.updateAmpChartOptions(this.state.descAmplitudePageMap.get(this.state.activePage - 1));
    }

    // And save that this is the active chart now
    this.setState({ activeChart: Constants.AMPLITUDE_ID });

    // Now that the user has selected one of the charts
    // allow the controls to be used
    this.setChartControlsDisabledState(false, false, false);
  }

  showNoiseGraph = () => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    if (this.state.isAddrCheckboxActive) {
      //console.log("this.state.ascNoisePageMap.get(this.state.activePage - 1)", this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1));
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.NOISE,
        data: this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1)
      }]);

      this.updateNoiseChartOptions(this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1));
    }
    else if (this.state.isAscCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.NOISE,
        data: this.state.ascNoisePageMap.get(this.state.activePage - 1)
      }]);

      this.updateNoiseChartOptions(this.state.ascNoisePageMap.get(this.state.activePage - 1));
    }
    else if (this.state.isDescCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.NOISE,
        data: this.state.descNoisePageMap.get(this.state.activePage - 1)
      }]);

      this.updateNoiseChartOptions(this.state.descNoisePageMap.get(this.state.activePage - 1));
    }

    // And save that this is the active chart now
    this.setState({ activeChart: Constants.NOISE_ID });

    // Now that the user has selected one of the charts
    // allow the controls to be used
    this.setChartControlsDisabledState(false, false, false);
  }

  showDeviationGraph = () => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    if (this.state.isAddrCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.DEVIATION,
        data: this.state.ascAddrcDeviationPageMap.get(this.state.activePage - 1)
      }]);

      this.updateDeviationChartOptions(this.state.ascAddrcDeviationPageMap.get(this.state.activePage - 1));
    }
    else if (this.state.isAscCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.DEVIATION,
        data: this.state.ascDeviationPageMap.get(this.state.activePage - 1)
      }]);

      this.updateDeviationChartOptions(this.state.ascDeviationPageMap.get(this.state.activePage - 1));
    }
    else if (this.state.isDescCheckboxActive) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
        name: Strings.DEVIATION,
        data: this.state.descDeviationPageMap.get(this.state.activePage - 1)
      }]);

      this.updateDeviationChartOptions(this.state.descDeviationPageMap.get(this.state.activePage - 1));
    }


    // And save that this is the active chart now
    this.setState({ activeChart: Constants.DEVIATION_ID });

    // Now that the user has selected one of the charts
    // allow the controls to be used
    this.setChartControlsDisabledState(false, false, false);
  }

  updateAmpChartOptions = (currentPageSeries) => {
    ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
      title: {
        text: Strings.AMPLITUDE,
        align: "center"
      },
      yaxis: {
        min: 0,
        max: Constants.AMPLITUDE_MAX_Y_AXIS,
        labels: {
          formatter: function (val) {
            return val.toFixed(2).replace(".", ",") + Strings.VOLTAGE_PEAK_TO_PEAK;
          },
        },
        title: {
          text: Strings.VOLTAGE_V_PEAK_TO_PEAK
        }
      },
      colors: [function ({ value }) {
        return (UtilsInstance.getASiBarGraphColorBasedOnValue(value, currentPageSeries, Constants));
      }],
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top",
          }
        }
      },
      dataLabels: {
        formatter: function (val) {
          if (val < 0) {
            // Don't show the number above a bar with
            // negative values
            return "";
          }
          else if (val === 0) {
            return "0,00";
          }
          else {
            return parseFloat(val).toFixed(2);
          }
        },
        style: {
          fontSize: "14px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 400,
          colors: ["#212121"],
        },
        offsetY: -22,
      },
    });
  }

  updateNoiseChartOptions = (currentPageSeries) => {
    ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
      title: {
        text: Strings.NOISE,
        align: "center"
      },
      yaxis: {
        min: 0,
        max: Constants.NOISE_MAX_Y_AXIS,
        labels: {
          formatter: function (val) {
            return val.toFixed(2).replace(".", ",") + Strings.VOLTAGE_PEAK_TO_PEAK;
          },
        },
        title: {
          text: Strings.VOLTAGE_V_PEAK_TO_PEAK
        }
      },
      colors: [function ({ value }) {
        return (UtilsInstance.getASiNoiseBarGraphColorBasedOnValue(value, currentPageSeries, Constants));
      }],
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top",
          }
        }
      },
      dataLabels: {
        formatter: function (val) {
          if (val < 0) {
            // Don't show the number above a bar with
            // negative values
            return "";
          }
          else if (val === 0) {
            return "0,00";
          }
          else {
            return parseFloat(val).toFixed(2);
          }
        },
        style: {
          fontSize: "14px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 400,
          colors: ["#212121"],
        },
        offsetY: -22,
      },
    });
  }

  updateDeviationChartOptions = (currentPageSeries) => {
    ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
      title: {
        text: Strings.DEVIATION,
        align: "center"
      },
      yaxis: {
        min: -Constants.DEVIATION_MAX_Y_AXIS,
        max: Constants.DEVIATION_MAX_Y_AXIS,
        labels: {
          formatter: function (val) {
            return val.toFixed(2) + Strings.MICROSSECOND;
          },
        },
        title: {
          text: Strings.MICROSSECOND_TITLE
        }
      },
      colors: [function ({ value }) {
        return (UtilsInstance.getASiDeviationBarGraphColorBasedOnValue(value, currentPageSeries, Constants));
      }],
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top",
          }
        }
      },
      dataLabels: {
        formatter: function (val) {
          if (val === 0.000032467532468) {
            return "";
          }
          else if (val === 0) {
            return "0,00";
          }
          else {
            return parseFloat(val).toFixed(2);
          }
        },
        style: {
          fontSize: "14px",
          fontFamily: "Helvetica, Arial, sans-serif",
          fontWeight: 400,
          colors: ["#212121"],
        },
        offsetY: -22,
      },
    });
  }

  /// ---------------- Mappings ----------------

  /// ---------------- AMPLITUDE ----------------

  // Ordered by device address ascending
  createAscAddrAmpPageMap = () => {
    let ascAddrAmpMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "order",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].amplitude),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1, status: "ok" });
          }
        }

      }

      ascAddrAmpMap.set(i, ampPageSeries);
    }

    return ascAddrAmpMap;
  }

  // Ordered by amplitude value ascending
  createAscAmpPageMap = () => {
    let ascAmpMap = new Map();

    let ascAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitude",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAmpSortedDevices.length);
      }
      else {
        devicesSlice = ascAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].amplitude),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1, status: "ok" });
          }
        }

      }

      ascAmpMap.set(i, ampPageSeries);
    }

    return ascAmpMap;
  }

  // Ordered by amplitude value descending
  createDescAmpPageMap = () => {
    let descAmpMap = new Map();

    let descAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitude",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descAmpSortedDevices.length);
      }
      else {
        devicesSlice = descAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].amplitude),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1, status: "ok" });
          }
        }

      }

      descAmpMap.set(i, ampPageSeries);
    }

    return descAmpMap;
  }

  /// ---------------- NOISE ----------------
  // Ordered by device address ascending
  createAscAddrNoisePageMap = () => {
    let ascAddrNoiseMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "order",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let noisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        noisePageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].noise),
          ampValue: parseFloat(devicesSlice[j].amplitude),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - noisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            noisePageSeries.push({ x: "", y: -1.0, ampValue: -1.0, status: "ok" });
          }
        }

      }

      ascAddrNoiseMap.set(i, noisePageSeries);
    }

    return ascAddrNoiseMap;
  }

  // Ordered by noise ascending
  createAscNoisePageMap = () => {
    let ascNoiseMap = new Map();

    let ascNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noise",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascNoiseSortedDevices.length);
      }
      else {
        devicesSlice = ascNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let noisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        noisePageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].noise),
          ampValue: parseFloat(devicesSlice[j].amplitude),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - noisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            noisePageSeries.push({ x: "", y: -1.0, ampValue: -1.0, status: "ok" });
          }
        }

      }

      ascNoiseMap.set(i, noisePageSeries);
    }

    return ascNoiseMap;
  }

  // Ordered by noise value descending
  createDescNoisePageMap = () => {
    let descNoiseMap = new Map();

    let descNoiseSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "noise",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descNoiseSortedDevices.length);
      }
      else {
        devicesSlice = descNoiseSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let noisePageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        noisePageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].noise),
          ampValue: parseFloat(devicesSlice[j].amplitude),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - noisePageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            noisePageSeries.push({ x: "", y: -1.0, ampValue: -1.0, status: "ok" });
          }
        }

      }

      descNoiseMap.set(i, noisePageSeries);
    }

    return descNoiseMap;
  }

  /// ---------------- DEVIATION ----------------
  // Ordered by device address ascending
  createAscAddrDeviationPageMap = () => {
    let ascAddrDeviationMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "order",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let deviationPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        deviationPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].deviation),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - deviationPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            deviationPageSeries.push({ x: "", y: 0.000032467532468, status: "ok" });
          }
        }

      }

      ascAddrDeviationMap.set(i, deviationPageSeries);
    }

    return ascAddrDeviationMap;
  }

  // Ordered by deviation ascending
  createAscDeviationPageMap = () => {
    let ascDeviationMap = new Map();

    let ascDeviationSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "deviation",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascDeviationSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascDeviationSortedDevices.length);
      }
      else {
        devicesSlice = ascDeviationSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let deviationPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        deviationPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].deviation),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - deviationPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            deviationPageSeries.push({ x: "", y: 0.000032467532468, status: "ok" });
          }
        }

      }

      ascDeviationMap.set(i, deviationPageSeries);
    }

    return ascDeviationMap;
  }

  // Ordered by deviation value descending
  createDescDeviationPageMap = () => {
    let descDeviationMap = new Map();

    let descDeviationSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "deviation",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descDeviationSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descDeviationSortedDevices.length);
      }
      else {
        devicesSlice = descDeviationSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let deviationPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        deviationPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: parseFloat(devicesSlice[j].deviation),
          status: devicesSlice[j].status
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - deviationPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            deviationPageSeries.push({ x: "", y: 0.000032467532468, status: "ok" });
          }
        }

      }

      descDeviationMap.set(i, deviationPageSeries);
    }

    return descDeviationMap;
  }

  // ---------------- Dropdown ----------------
  onDropdownChange = (e, { value }) => {
    if (value === "amplitude") {
      this.setState({
        graphType: value,
        ascCheckboxLabel: Strings.AMPLITUDE_ASC,
        descCheckboxLabel: Strings.AMPLITUDE_DESC,
      }, () => {
        this.showAmpGraph();
      });
    }
    else if (value === "noise") {
      this.setState({
        graphType: value,
        ascCheckboxLabel: Strings.NOISE_ASC,
        descCheckboxLabel: Strings.NOISE_DESC,
      }, () => {
        this.showNoiseGraph();
      });
    }
    else if (value === "deviation") {
      this.setState({
        graphType: value,
        ascCheckboxLabel: Strings.DEVIATION_ASC,
        descCheckboxLabel: Strings.DEVIATION_DESC,
      }, () => {
        this.showDeviationGraph();
      });
    }
  }

  // ---------------- Buttons and Checkboxes active state ----------------
  setChartControlsDisabledState = (ampAddrCheckboxState, ampAscCheckboxState, ampDescCheckboxState) => {
    document.getElementById("amp-addr-checkbox").disabled = ampAddrCheckboxState;
    document.getElementById("amp-asc-checkbox").disabled = ampAscCheckboxState;
    document.getElementById("amp-desc-checkbox").disabled = ampDescCheckboxState;
  }

  // ---------------- Classification Options ----------------
  handleOrderCheckboxChange = (e, { value }) => {
    if (value === Constants.CHECKBOX_ADDR_VAL) {
      this.setState({
        isAddrCheckboxActive: true,
        isAscCheckboxActive: false,
        isDescCheckboxActive: false,
      }, () => {
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
          }]);
          this.updateAmpChartOptions(this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1));
        }
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1)
          }]);
          this.updateNoiseChartOptions(this.state.ascAddrcNoisePageMap.get(this.state.activePage - 1));
        }
        else if (this.state.activeChart === Constants.DEVIATION_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.DEVIATION,
            data: this.state.ascAddrcDeviationPageMap.get(this.state.activePage - 1)
          }]);
          this.updateDeviationChartOptions(this.state.ascAddrcDeviationPageMap.get(this.state.activePage - 1));
        }
      });
    }
    else if (value === Constants.CHECKBOX_ASC_VAL) {
      this.setState({
        isAddrCheckboxActive: false,
        isAscCheckboxActive: true,
        isDescCheckboxActive: false,
      }, () => {
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updateAmpChartOptions(this.state.ascAmplitudePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascNoisePageMap.get(this.state.activePage - 1)
          }]);
          this.updateNoiseChartOptions(this.state.ascNoisePageMap.get(this.state.activePage - 1));
        }
        else if (this.state.activeChart === Constants.DEVIATION_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.DEVIATION,
            data: this.state.ascDeviationPageMap.get(this.state.activePage - 1)
          }]);
          this.updateDeviationChartOptions(this.state.ascDeviationPageMap.get(this.state.activePage - 1));
        }
      });
    }
    else if (value === Constants.CHECKBOX_DESC_VAL) {
      this.setState({
        isAddrCheckboxActive: false,
        isAscCheckboxActive: false,
        isDescCheckboxActive: true,
      }, () => {
        // Order the active chart by amplitude descending
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.descAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updateAmpChartOptions(this.state.descAmplitudePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.descNoisePageMap.get(this.state.activePage - 1)
          }]);
          this.updateNoiseChartOptions(this.state.descNoisePageMap.get(this.state.activePage - 1));
        }
        else if (this.state.activeChart === Constants.DEVIATION_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.DEVIATION,
            data: this.state.descDeviationPageMap.get(this.state.activePage - 1)
          }]);
          this.updateDeviationChartOptions(this.state.descDeviationPageMap.get(this.state.activePage - 1));
        }
      });
    }
  }

  // ---------------- Pagination ----------------
  handlePageChange = (e, { activePage }) => {
    this.setState({ activePage: activePage }, () => {
      // Check which of the checkboxes are active first
      if (this.state.isAddrCheckboxActive) {
        // Then check which of the charts are active
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAddrcAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updateAmpChartOptions(this.state.ascAddrcAmplitudePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascAddrcNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updateNoiseChartOptions(this.state.ascAddrcNoisePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.DEVIATION_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.DEVIATION,
            data: this.state.ascAddrcDeviationPageMap.get((this.state.activePage - 1))
          }]);
          this.updateDeviationChartOptions(this.state.ascAddrcDeviationPageMap.get((this.state.activePage - 1)));
        }
      }
      else if (this.state.isAscCheckboxActive) {
        // Then check which of the charts are active
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.ascAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updateAmpChartOptions(this.state.ascAmplitudePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.ascNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updateNoiseChartOptions(this.state.ascNoisePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.DEVIATION_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.DEVIATION,
            data: this.state.ascDeviationPageMap.get((this.state.activePage - 1))
          }]);
          this.updateDeviationChartOptions(this.state.ascDeviationPageMap.get((this.state.activePage - 1)));
        }
      }
      else if (this.state.isDescCheckboxActive) {
        // Then check which of the charts are active
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.AMPLITUDE,
            data: this.state.descAmplitudePageMap.get((this.state.activePage - 1))
          }]);
          this.updateAmpChartOptions(this.state.descAmplitudePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.NOISE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.NOISE,
            data: this.state.descNoisePageMap.get((this.state.activePage - 1))
          }]);
          this.updateNoiseChartOptions(this.state.descNoisePageMap.get((this.state.activePage - 1)));
        }
        else if (this.state.activeChart === Constants.DEVIATION_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.DEVIATION,
            data: this.state.descDeviationPageMap.get((this.state.activePage - 1))
          }]);
          this.updateDeviationChartOptions(this.state.descDeviationPageMap.get((this.state.activePage - 1)));
        }
      }
    });
  }

  /// ---------------- Error Messages -----------------------------
  retrieveWarnings = async () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "warnings/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
      .then(res => res.json())
      .then(data => {
        this.handleWarningMessages(data);
      });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.scanFail || errors.picoNotFound || errors.invertedPolarity) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "block";
      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.firstScanFail) {
        errorMessages.push(Strings.NO_ACTIVE_NETWORK);
      }

      if (errors.mongoOFF) {
        errorMessages.push(Strings.MONGO_OFF);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.scanFail) {
        errorMessages.push(Strings.SCAN_FAIL_FOUND);
      }

      if (errors.invertedPolarity) {
        errorMessages.push(Strings.INVERTED_POLARITY_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {
        document.getElementById("message-list").style.display = "none";
      }

      if (document.getElementById("repair-button") !== undefined
        && document.getElementById("repair-button") !== null) {
        document.getElementById("repair-button").style.display = "none";
      }

      this.setState({ errorMessages: [] });
    }
  }

  /// ---------------- Errors Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
    this.retrieveWarnings();
    this.retrievePercentData();
    this.setState({
      retrieveDataIntervalID: setInterval(this.retrieveData, 500),
      warningsIntervalID: setInterval(this.retrieveWarnings, 5000),
      percentIntervalID: setInterval(this.retrievePercentData, 5000)
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.retrieveDataIntervalID);
    clearInterval(this.state.warningsIntervalID);
    clearInterval(this.state.percentIntervalID);
  }

  render() {

    return (
      <DimmerDimmable style={dimmerStyle} as="div" dimmed={(this.state.percent < 100)}>

        <div style={screenStyle}>

          <Grid columns={2} doubling>

            <Grid.Row>

              <Grid.Column width={4}>

                <Segment>
                  <Divider horizontal style={dividerStyle}>{Strings.GRAPH}</Divider>
                  <Dropdown
                    disabled={this.state.isDropdownDisabled}
                    placeholder={Strings.BAR_GRAPH_TYPE_PLACEHOLDER}
                    fluid
                    selection
                    options={dropdownOptions}
                    onChange={this.onDropdownChange} />
                </Segment>

                <Segment id="order-seg">
                  <Divider horizontal style={dividerStyle}>{Strings.ORDER_BY}</Divider>

                  <Form style={formStyle}>
                    <Form.Field style={formFieldStyle}>
                      <Checkbox
                        id="amp-addr-checkbox"
                        radio
                        label={Strings.ADDRESS_ASC}
                        checked={this.state.isAddrCheckboxActive}
                        value={Constants.CHECKBOX_ADDR_VAL}
                        onChange={this.handleOrderCheckboxChange}
                      />
                    </Form.Field>
                    <Form.Field style={formFieldStyle}>
                      <Checkbox
                        id="amp-asc-checkbox"
                        radio
                        label={this.state.ascCheckboxLabel}
                        checked={this.state.isAscCheckboxActive}
                        value={Constants.CHECKBOX_ASC_VAL}
                        onChange={this.handleOrderCheckboxChange}
                      />
                    </Form.Field>
                    <Form.Field style={formFieldStyle}>
                      <Checkbox
                        id="amp-desc-checkbox"
                        radio
                        label={this.state.descCheckboxLabel}
                        checked={this.state.isDescCheckboxActive}
                        value={Constants.CHECKBOX_DESC_VAL}
                        onChange={this.handleOrderCheckboxChange}
                      />
                    </Form.Field>
                  </Form>

                </Segment>

                <Accordion id="message-list" styled style={accordionStyle}>
                  <Accordion.Title
                    style={accordionTitleStyle}
                    active={this.state.accordionIndex === 1}
                    index={1}
                    onClick={this.handleAccordionClick}
                  >
                    <Icon name="exclamation triangle" />
                    {Strings.DETECTED_PROBLEMS}
                    <Icon name="dropdown" />
                  </Accordion.Title>
                  <Accordion.Content active={this.state.accordionIndex === 1}>
                    <div style={accordionListItemsStyle}>
                      <ul style={{ paddingLeft: 0 }}>
                        {this.state.errorMessages.map((message) => (
                          <li key={message}>{message}</li>
                        ))}
                      </ul>
                    </div>
                  </Accordion.Content>
                </Accordion>

              </Grid.Column>

              <Grid.Column width={12}>
                <Segment>

                  <Chart
                    id="amp-chart"
                    options={this.state.options}
                    series={[{ name: Strings.AMPLITUDE, data: [] }]}
                    height={UtilsInstance.adjustChartHeight()}
                    type="bar" />

                  <Pagination
                    style={paginationStyle}
                    id="pagination"
                    activePage={this.state.activePage}
                    onPageChange={this.handlePageChange}
                    totalPages={this.state.numOfPages} />

                </Segment>

              </Grid.Column>

            </Grid.Row>
          </Grid>

        </div>

        <Dimmer inverted active={(this.state.percent < 100)}>
          <InitLoader ref={this.InitLoaderRef} />
        </Dimmer>
      </DimmerDimmable >
    );
  }
}

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel
});

const screenStyle = {
  margin: "4vh 2vw",
  textAlign: "center",
};

const formStyle = {
  marginTop: "-1vh",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "-2vh"
};

const formFieldStyle = {
  marginBottom: "-1vh"
};

const paginationStyle = {
  visibility: "hidden"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

const dimmerStyle = {
  zIndex: 1
};

export default connect(mapStateToProps)(withRouter(BarGraph));
